export default function GS_Get_Started() {
  return (
    <div className="p-4">
      <h1>GS Get Started</h1>
    </div>
  );
}
